import { useTranslation } from 'react-i18next'

import Bell from '@/public/images/bell2.svg'
import Completed from '@/public/images/completed.svg'

import { NotificationStatus } from '../../types'

interface EmptyNotificationStateProps {
  tab: NotificationStatus
}

export const EmptyNotificationState = ({
  tab,
}: EmptyNotificationStateProps) => {
  const { t } = useTranslation()

  const isUnread = tab === NotificationStatus.Unread

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center min-h-[150px]">
      <img src={isUnread ? Completed : Bell} alt="No notifications" />
      <h3 className="text-md font-semibold text-primary-900 m-0 mt-4">
        {t(
          isUnread
            ? 'notifications.empty.unread.title'
            : 'notifications.empty.read.title'
        )}
      </h3>
      <p className="text-sm text-tertiary-600 m-0.5 ">
        {t(
          isUnread
            ? 'notifications.empty.unread.description'
            : 'notifications.empty.read.description'
        )}
      </p>
    </div>
  )
}
